import React, {useState,useEffect} from 'react';
import GapiFetchItemsList from "../../Components/DriveConnector/GapiFetchItemsList";
import {callGoogleAuthAPI} from "../../api/googleAuth";

const DriveConnector = () => {
    // ルート共有フォルダを設定
    const [items, setItems] = useState([]);
    const [isFilesLoaded,setIsFilesLoaded] = useState(false);

    //　ルートフォルダを取得
    useEffect(() => {
        const fetchData = async () => {
            // ルートフォルダを取得
            const data = await callGoogleAuthAPI();

            // すでにカレントフォルダを変更済みの場合は処理を終了
            if (items.length !== 0) {
                return;
            }

            const urlParams = new URLSearchParams(window.location.search);
            const id = urlParams.get('id');
            const dc = urlParams.get('dc');

            let newItems = data; // 初期値として data をセット

            try {
                if (dc !== null) {
                    if (id !== null) {
                        // driveConnector が設定されていて、id もある場合
                        for (const val of data) {
                            if (val.name.startsWith(dc)) {
                                const res = await callGoogleAuthAPI(val.id);
                                if (res.length !== 0) {
                                    // 一致する id を持つアイテムを検索
                                    let found = false;
                                    for (const v of res) {
                                        if (v.name.startsWith(id)) {
                                            const r = await callGoogleAuthAPI(v.id);
                                            newItems = r;
                                            found = true;
                                            break;
                                        }
                                    }
                                    if (!found) {
                                        // driveConnector で一致するフォルダは見つかったが id は一致しない場合
                                        newItems = res;
                                    }
                                }
                            }
                            // driveConnector は存在するが、一致するフォルダを見つけられない場合は newItems は data のまま
                        }
                    } else {
                        // driveConnector は存在するが id が存在しない場合
                        for (const val of data) {
                            if (val.name.startsWith(dc)) {
                                const res = await callGoogleAuthAPI(val.id);
                                if (res.length !== 0) {
                                    newItems = res;
                                    break; // 一致するフォルダが見つかったらループを抜ける
                                }
                            }
                        }
                    }
                } else {
                    // driveConnector が存在しない場合
                    if (id !== null) {
                        for (const val of data) {
                            if (val.name.startsWith(id)) {
                                const res = await callGoogleAuthAPI(val.id);
                                if (res.length !== 0) {
                                    newItems = res;
                                    break;
                                }
                            }
                        }
                    }
                }
            } catch (error) {
                console.error("エラーが発生しました", error);
            }

            // すべての非同期処理が完了した時点で items を更新し、ローディングフラグを立てる
            setItems(newItems);
            setIsFilesLoaded(true);
        };

        fetchData();
        // ※ items に依存する場合は依存配列に items を入れる必要はあるが、ここでは初回のみの実行と仮定
    }, []);


    //フォルダーをクリックしたとき
    const handleFolderClick = (folderId) => {
        window.open(`https://drive.google.com/folder/d/${folderId}/view`)
    };

    // ファイルクリック時のハンドラーを追加
    const handleFileClick = (fileId) => {
        window.open(`https://drive.google.com/file/d/${fileId}/view`)
    };

    return (
        <div style={{padding: '20px'}}>
            {
                isFilesLoaded &&
                <GapiFetchItemsList items={items} onFolderClick={handleFolderClick} handleFileClick={handleFileClick} />
            }
        </div>
    );
};

export default DriveConnector;
